module.exports = __webpack_public_path__ + "static/pub-89bf4b96eba02a36cd3f620dbf8f1446.jpg";